import { BOOLEAN_RADIO_INPUT_OPTIONS } from "@constants/boolean-radio-input-options";
import { resources } from "@constants/hardcoded-strings";
import { ThemingFormGroupWrapper } from "@containers/common/theming-input-form-group/theming-form-group-wrapper";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { PageLevelTypes } from "@enums/page-level-types";
import { faUndo } from "@fortawesome/free-solid-svg-icons/faUndo";
import { AXNUILayout } from "@iddataweb/idw-common-ui/types";
import { isStringTrue } from "@iddataweb/idw-common-ui/utils";
import { RadioInputFormGroup } from "../../../../../common/radio-input-form-group/radio-input-form-group";
import { DEFAULT_AXNUI_LAYOUT } from "@iddataweb/idw-common-ui/constants";

type ThemingLayoutLanguageSelectorSectionProps = {
    layout: LayoutTypes;
    labelWidth: LabelWidthTypes;
    isDisabled: boolean;
    axnuiLayout: AXNUILayout;
    inheritedAXNUILayout: AXNUILayout;
    updateAXNUILayoutPropertyValue: (value: AXNUILayout) => void;
    pageLevel: PageLevelTypes;
};

export const ThemingLayoutLanguageSelectorSection = (props: ThemingLayoutLanguageSelectorSectionProps) => {
    const {
        layout,
        labelWidth,
        isDisabled,
        axnuiLayout,
        inheritedAXNUILayout,
        updateAXNUILayoutPropertyValue,
        pageLevel
    } = props;


    const handleLayoutChange = (key: keyof AXNUILayout, value: boolean) => {
        const newPropertyValue: AXNUILayout = {
            ...axnuiLayout,
            [key]: value
        };
        
        updateAXNUILayoutPropertyValue(newPropertyValue);
    };

    const handleToggleIsLanguageSelectorChange = (newValue: string) => {
        handleLayoutChange("isLanguageSelectorEnabled", isStringTrue(newValue));
    };

    const handleResetIsLanguageSelectorEnabled = () => {
        handleLayoutChange("isLanguageSelectorEnabled", DEFAULT_AXNUI_LAYOUT.isLanguageSelectorEnabled);
    };
    return (
        <div>
            <ThemingFormGroupWrapper
                inheritedThemingPropertyValue={inheritedAXNUILayout.isLanguageSelectorEnabled}
                currentThemingPropertyValue={axnuiLayout.isLanguageSelectorEnabled}
                pageLevel={pageLevel}
            >
                <RadioInputFormGroup
                    controlId={"theming-layout-language-selector-radio-input"}
                    automationId={"theming-layout-language-selector-radio-input"}
                    label={resources.pages.verificationServiceDetails.tabs.theming.subTabs.layout.sections.languageSelector.inputs.enableLanguageSelector.label}
                    layout={layout}
                    labelWidth={labelWidth}
                    onChange={handleToggleIsLanguageSelectorChange}
                    options={BOOLEAN_RADIO_INPUT_OPTIONS}
                    value={axnuiLayout.isLanguageSelectorEnabled ? "true" : "false"}
                    disabled={isDisabled}
                    isRequired={true}
                    afterLabelTooltipText={resources.pages.verificationServiceDetails.tabs.theming.subTabs.layout.sections.languageSelector.inputs.enableLanguageSelector.tooltip}
                    afterLabelIcon={isDisabled ? null : faUndo}
                    afterLabelIconOnClick={handleResetIsLanguageSelectorEnabled}
                />
            </ThemingFormGroupWrapper>
        </div>
    );
};